export default snapshot => ({ id: snapshot.id, ...snapshot.data() })